<template>
    <span
        ref="target"
        :style="opacityStyle"
        class="transition-all duration-300">
        {{ counter }}
    </span>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'

const props = defineProps({
    count: {
        type: Number as PropType<number>,
        default: 0,
    },
    duration: {
        type: Number as PropType<number>,
        default: 3500,
    },
})

const AGGRESSIVE = 3

const isCounterStarted = ref(false)

const counter = ref(0)
let startTime: number | null = null

const opacityStyle = computed(() => {
    return `opacity: ${Math.max(0.05, counter.value / props.count)};`
})

function getIncreaseFactor(progress: number): number {
    return 1 - Math.pow(1 - progress, AGGRESSIVE)
}

function startCounter() {
    counter.value = 0
    startTime = null
    window.requestAnimationFrame(step)
}

const target = ref(null)

useIntersectionObserver(target, ([entry], observer) => {
    if (isCounterStarted.value) observer.disconnect()

    if (entry?.isIntersecting) {
        isCounterStarted.value = true
        setTimeout(startCounter, getRandomNumber(0, 500))
    }
})

const step = (timestamp: number) => {
    if (!startTime) startTime = timestamp

    const timeLeft = timestamp - startTime
    const progress = Math.min(timeLeft / props.duration, 1)
    const increaseFactor = getIncreaseFactor(progress)

    counter.value = Math.floor(props.count * increaseFactor)

    if (progress < 1) window.requestAnimationFrame(step)
}
</script>
